<template>
  <div>
    <b-container class="home-container text-left">
      <b-row class="mb-3">
        <b-col sm="12" md="10 mb-lg-4">
          <h1 class="pt-3 mb-lg-4">ESG Kompetencia Központ</h1>
        </b-col>
      </b-row>
      <b-row class="wrapper goals-section">
        <b-col>
          <h2 class="p-5 text-left">
            A Magyar Gazdaságfejlesztési Ügynökség ESG Törvény szerint rögzített, kiemelt feladatai:
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <div class="esg-diagram-container">
          <!-- Asztali kép -->
          <!-- <img src="../assets/img/ESG/Borító.svg" alt="ESG diagram desktop" class="esg-image desktop-image" /> -->
          <!-- Mobil kép -->
          <img
            src="../assets/img/ESG/ESG_KK_cover_mobil.jpg"
            alt="ESG diagram mobile"
            class="esg-image
            mobile-image pl-3"
          />
        </div>
      </b-row>
      <b-container class="competence-wrapper competence-section mt-4 d-none d-md-block">
        <div class="competence-overlay">
          <div class="competence-box competence-box-1">
            <p class="competence-text">
              MGFÜ ESG <br />
              Kompetencia <br />
              Központ <br />
            </p>
          </div>
          <div class="competence-box competence-box-2">
            <img
              class="arrow-down arrow-down--mirrored d-lg-inline"
              src="../assets/img/business-development-services/arrow-down.svg"
            />
            <a href="#tanacsadasi" class="competence-text">Tanácsadási szolgáltatások</a>
          </div>
          <img
            class="arrow-down arrow-down--mirrored-2 d-none d-lg-inline"
            src="../assets/img/business-development-services/arrow-down.svg"
          />
          <div class="competence-box competence-box-3">
            <a href="#oktatasi" class="competence-text">Oktatási és képzést támogató szolgáltatások</a>
          </div>
          <div class="competence-box competence-box-4">
            <img
              class="arrow-down d-none d-lg-inline"
              src="../assets/img/business-development-services/arrow-down.svg"
            />
            <a href="#hatosagi" class="competence-text">Hatósági feladatok</a>
          </div>
        </div>
      </b-container>
      <b-container class="d-block d-md-none competence-mobile mt-4">
        <div class="competence-box-mobile competence-box-mobile-1">
          <p class="competence-text">
            MGFÜ ESG <br />
            Kompetencia <br />
            Központ
          </p>
        </div>

        <div class="competence-box-mobile competence-box-mobile-2">
          <a href="#tanacsadasi" class="competence-text-mobile">
            Tanácsadási szolgáltatások
          </a>
        </div>

        <div class="competence-box-mobile competence-box-mobile-3">
          <a href="#oktatasi" class="competence-text-mobile">
            Oktatási és képzést támogató szolgáltatások
          </a>
        </div>

        <div class="competence-box-mobile competence-box-mobile-4">
          <a href="#hatosagi" class="competence-text-mobile">
            Hatósági feladatok
          </a>
        </div>
      </b-container>
      <b-row class="wrapper goals-section mt-4">
        <b-row class="ml-5 mt-4 pt-2 mb-5">
          <h3 class="section-title">Célok</h3>
        </b-row>
        <b-row class="cards-container p-3 mt-5 pt-5">
          <b-col class="goal-card first-card">
            <div class="icon circle-background">
              <img src="../assets/img/ESG/picto1.svg" class="icon-img" />
            </div>
            <h4 class="goal-title">Innováció</h4>
            <p class="goal-text">
              A vállalkozások képesek legyenek innovációt generálni
            </p>
          </b-col>

          <b-col class="goal-card second-card">
            <div class="icon circle-background">
              <img src="../assets/img/ESG/picto2.svg" class="icon-img" />
            </div>
            <h4 class="goal-title">Versenyképesség</h4>
            <p class="goal-text">
              Hosszú távon versenyképesség megőrzése és erősítése a hazai és nemzetközi piacokon
            </p>
          </b-col>

          <b-col class="goal-card third-card">
            <div class="icon circle-background">
              <img src="../assets/img/ESG/picto3.svg" class="icon-img" />
            </div>
            <h4 class="goal-title">Reziliencia</h4>
            <p class="goal-text">
              Reziliens működési modellek kialakítása
            </p>
          </b-col>
        </b-row>
        <p class="footer-text">
          Az ESG Kompetencia Központot a Magyar Gazdaságfejlesztési Ügynökség Fenntartható Versenyképességi Osztálya
          működteti
        </p>
      </b-row>
    </b-container>
    <b-container class="home-container text-left">
      <span id="tanacsadasi"></span>
      <b-row class="mb-4 mt-5">
        <b-col sm="12" md="8">
          <h1>Szolgáltatások</h1>
        </b-col>
      </b-row>

      <!-- TANÁCSADÁSI SZOLGÁLTATÁSOK -->
      <div>
        <b-row class="mb-4">
          <b-col cols="12" class="services-wrapper mt-4">
            <h2 class="title">TANÁCSADÁSI SZOLGÁLTATÁSOK</h2>
            <h3 class="sub-title mt-2">Fenntarthatósági mentorálás - DNSH</h3>
            <ul>
              <li>
                <span style="color:#00903C; font-size:18px;">✔</span>
                A vállalkozások megismerkedhetnek az ESG három pillérével:
              </li>
              <ul>
                <li><strong>E</strong> – Környezeti fenntarthatóság</li>
                <li><strong>S</strong> – Társadalmi fenntarthatóság</li>
                <li><strong>G</strong> – Vállalatirányítás és vállalati felelősségvállalás</li>
              </ul>

              <li>
                <span style="color:#00903C; font-size:18px;">✔</span>
                Gyakorlati példákon keresztül kapnak iránymutatást saját szervezetük fejlesztéséhez
              </li>
              <li>
                <span style="color:#00903C; font-size:18px;">✔</span>
                A 3 órás mentorálási alkalom során az Ügyfelek megismerkedhetnek az alábbi kulcsterületekkel, online –
                webinar formában:
              </li>

              <ol>
                <li class="dot_pill">alkalom – Környezeti fenntarthatóság (1 óra)</li>
                <p class="dot_section">
                  Üvegházhatású gázok kibocsátása, dekarbonizációs stratégiák. Energiafelhasználás és
                  energiahatékonysági megoldások. Szennyezések (levegő, víz, talaj) csökkentése, vízfelhasználás
                  mérséklése. Biodiverzitás védelme, hulladékgazdálkodás, körforgásos gazdaság. DNSH (Do No Significant
                  Harm) elvnek való megfelelés.
                </p>
                <li class="dot_pill">alkalom – Társadalmi fenntarthatóság (1 óra)</li>
                <p class="dot_section">
                  Egyenlő foglalkoztatási esélyek, azonos munkavállalói juttatások. Munkahelyi biztonság és
                  egészségvédelem. Munkavállalói elkötelezettség és családbarát működés erősítése. Helyi közösségek
                  bevonása, civil kezdeményezések támogatása.
                </p>
                <li class="dot_pill">alkalom – Vállalatirányítás és felelősségvállalás (1 óra)</li>
                <p class="dot_section">
                  Vállalatirányítási és felelősségvállalási gyakorlatok. Kockázatkezelés, compliance, etikus üzleti
                  magatartás. Átláthatóság növelése, greenwashing elkerülése. Ellátási láncban való felelősségvállalás.
                </p>
              </ol>
            </ul>
            <div class="download-buttons">
              <a
                class="download-pill"
                download
                target="_blank"
                href="https://vali.hu/static/Programleiras_Fenntarthatosagi_mentoralas.pdf"
              >
                <span>Programleírás</span>
                <img src="../assets/img/icons/download.svg" />
              </a>

              <a
                class="download-pill"
                download
                target="_blank"
                href="https://vali.hu/static/De_minimis_2026_tajekoztato.pdf"
              >
                <span>De minimis tájékoztató</span>
                <img src="../assets/img/icons/download.svg" />
              </a>

              <a
                class="download-pill"
                download
                target="_blank"
                href="https://vali.hu/static/Nyilatkozat_reszveteli_es_jelentkezesi_feltetelek_elfogadasarol.docx"
              >
                <span>Nyilatkozat</span>
                <img src="../assets/img/icons/download.svg" />
              </a>

              <a
                class="download-pill"
                download
                target="_blank"
                href="https://vali.hu/static/Meghatalmazas_Fenntarthatosagi_mentoralas.docx"
              >
                <span>Meghatalmazás</span>
                <img src="../assets/img/icons/download.svg" />
              </a>
            </div>
            <span id="oktatasi"></span>
            <a
              class="services-button-wrapper application-button"
              href="https://forms.office.com/e/SnhVPkubw8?origin=lprLink"
              target="_blank"
              rel="noopener"
            >
              <div>
                <p class="mb-0">Jelentkezési űrlap kitöltése</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#008237" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>

      <!-- OKTATÁSI ÉS KÉPZÉST TÁMOGATÓ SZOLGÁLTATÁSOK -->
      <div>
        <b-row class="mb-4">
          <b-col cols="12" class="services-wrapper mt-4">
            <h2 class="title">OKTATÁSI ÉS KÉPZÉST TÁMOGATÓ SZOLGÁLTATÁSOK</h2>
            <p class="strong-highlight mb-2">E-learning: KKV-k ESG és fenntarthatósági témájú felkészítése</p>
            <p class="p-1">
              Készülj fel időben a fenntarthatósági elvárásokra – és fordítsd valódi üzlei előnnyé az ESG-t!
            </p>
            <p class="p-2">
              Az ESG nem csupán egy újabb megfelelési kötelezettség, hanem egy olyan szemlélet, amely segít eligazodni a
              változó gazdasági környezetben. A képzés az elvárásoknak való megfelelés mellett, abban is támogat, hogy
              <strong>
                átlásd az összefüggéseket, tudatos döntéseket hozz, és vállalkozásod számára is értéket teremts.
              </strong>
            </p>
            <b-row class="mb-3 mb-md-5 mt-3">
              <b-col cols="12" lg="8">
                <h3 class="mb-4 dot_pill_2">ESG alapjai KKV-k számára</h3>
                <ul class="mb-4">
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    az ESG alapfogalmainak és jelentőségének bemutatása
                  </li>
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    a KKV-k ESG érintettségének megértése
                  </li>
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    az ESG bevezetésének és fenntartásának költségei
                  </li>
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    gyakorlati lépések az ESG beépítésére a vállalati működésbe
                  </li>
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    az ESG ökoszisztéma és főbb szereplői
                  </li>
                  <li>
                    <span style="color:#00903C; font-size:18px;">✔</span>
                    az ESG és a fenntartható működés üzleti előnyei
                  </li>
                </ul>
                <b-button
                  class="button w-md-100 mt-4"
                  href="https://forms.office.com/e/MrxhQTV1n5?origin=lprLink"
                  target="_blank"
                >
                  Elkezdem a képzést
                </b-button>
              </b-col>
              <b-col cols="3" class="img p-0 justify-content-end d-lg-block d-none ml-lg-n5">
                <img src="../assets/img/study_icon.png" />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="services-wrapper mt-4">
            <!-- <p class="strong-highlight mb-2">E-learning tananyag</p>
            <ul class="dot">
              <li>
                A vállalkozások ESG felkészültségének fejlesztése a vállalkozások munkavállalói, partnerei (beszállítói)
                számára, az ESG-vel együtt járó teendők elvégzésében és azok csökkentésében
              </li>
            </ul> -->
            <p class="strong-highlight mb-2">Piaci tréningek</p>
            <ul class="dot">
              <li>ESG és fenntarthatósági képzések nyilvántartása egy helyen a vállalkozások számára</li>
            </ul>
            <span id="hatosagi"></span>
            <a class="services-button-wrapper" href="/ESG/Treningek" @click="$emit('openTraining')">
              <div><p class="mb-0">Tovább a tréningekre</p></div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>

      <!-- HATÓSÁGI FELADATOK -->
      <div>
        <b-row class="mb-4">
          <b-col cols="12" class="services-wrapper">
            <h2 class="title">HATÓSÁGI FELADATOK</h2>
            <p class="strong-highlight mb-2">Intézményi akkreditáció</p>
            <ul class="dot">
              <li>Az MGFÜ akkreditációs hatóságként jár el ESG tanácsadókat oktató intézmények esetében.</li>
              <li>Akkreditált intézmény jogosult ESG tanácsadói képesítés igazolására</li>
              <li>
                Részletes szabályozás: 30/2024. (VIII.8.) NGM rendelet; eljárás: 244/2024. (VIII.8.) Korm. rendelet
              </li>
              <li>
                Információk, sablonok és útmutatók:
                <a href="/ESG/Akkreditacio" target="_blank">vali.hu/ESG/Akkreditacio</a>
              </li>
            </ul>
            <p class="strong-highlight mb-2">ESG tanácsadók és oktatók koordinálása</p>
            <ul class="dot">
              <li>
                Hatósági és szervezési feladatok a gördülékeny akkreditáció és oktatói kapcsolatépítés érdekében
              </li>
            </ul>
            <p class="strong-highlight mb-2">Nyilvántartás vezetése</p>
            <ul class="dot">
              <li>
                Elektronikus nyilvántartás az akkreditált intézményekről: vali.hu/Akkreditált intézmények.
              </li>
            </ul>
            <a class="services-button-wrapper" href="/ESG/Intezmenyek" target="_blank">
              <div><p class="mb-0">Tovább a nyilvántartásra</p></div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <ESGButton />
  </div>
</template>

<script>
//import CurvedArrow from './CurvedArrow.vue'
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGSercies',
  components: {
    ESGButton
    //CurvedArrow
  }
}
</script>

<style scoped>
.download-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  margin-top: 1.5rem;
}

.download-pill {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 10px 18px;
  min-width: 180px;

  background: #ffffff; /* világos szürke */
  border-radius: 999px; /* pill forma */

  text-decoration: none;
  color: #00903c;
  font-weight: 600;
  font-size: 0.9rem;

  transition: all 0.2s ease;
}

.download-pill img {
  width: 18px;
  height: 18px;
}

.download-pill:hover {
  background: #e5e7eb;
  transform: translateY(-2px);
}
.download-pill {
  flex: 1 1 calc(25% - 24px);
}

@media (max-width: 768px) {
  .download-pill {
    flex: 1 1 calc(50% - 12px);
  }
}

.dot_pill {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 10px 18px;
  min-width: 180px;

  background: #ffffff; /* világos szürke */
  border-radius: 999px; /* pill forma */

  text-decoration: none;
  color: #00903c;
  font-weight: 600;
  font-size: 0.9rem;

  transition: all 0.2s ease;
}
.dot_pill_2 {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 10px 18px;
  min-width: 510px;

  background: #ffffff; /* világos szürke */
  border-radius: 999px; /* pill forma */

  text-decoration: none;
  color: #00903c;
  font-weight: 800;
  font-size: 24px;

  transition: all 0.2s ease;
}
#application-form-button {
  pointer-events: none;
  opacity: 0.7;
  cursor: not-allowed;
}
/* Jelentkezési űrlap kitöltése gomb kikapcsolás*/
#application-form-button {
  pointer-events: none;
  opacity: 0.7;
  cursor: not-allowed;
}
.esg-diagram-container {
  position: relative;
  text-align: center;
}

/* Tanácsadási szolgáltatások */

.services-wrapper {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

/* Főcím (uppercase, zöld) */
.title {
  font-weight: 700;
  margin-bottom: 1rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  text-transform: uppercase;
  color: #00903c;
  border-bottom: 4px solid #00903c33;
  font-size: 2rem;
  font-weight: normal !important;
}

.sub-title {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  font-weight: normal !important;
  color: #00903c;
  font-size: 1.4rem;
  margin-bottom: 1rem;
}

.services-button-wrapper {
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
  cursor: pointer;
  color: #00903c;
  font-weight: 700;
  text-decoration: none;
}

.services-button-wrapper div:first-child p {
  margin: 0;
  font-size: 1rem;
}

.services-button-wrapper div:last-child svg {
  fill: #00903c;
}

/* Alapból rejtett a mobil kép */
.mobile-image {
  display: none;
  width: 97%;
  max-width: 100%; /* vagy igény szerint */
}

/* Asztali kép alapértelmezett */
.desktop-image {
  display: block;
  width: 100%;
  max-width: 100%; /* vagy igény szerint */
}

.arrow-down {
  position: absolute;
  right: 220px;
  top: -100px;
  height: 180px;
}

.arrow-down--mirrored {
  transform: scaleY(-1);
  height: 180px;
  top: -20px;
}

.arrow-down--mirrored-2 {
  transform: scaleY(-1) rotate(-332deg);
  height: 180px;
  margin-right: -35px;
  margin-top: 30px;
  width: auto;
  right: -220px;
  top: 230px;
  clip-path: inset(0 0 0 85%);
}

/* Mobilnézet (max 768px) */
@media (max-width: 768px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

.goals-section {
  background-color: #f7fbfc; /* világos háttér a blokk számára */
  text-align: center;
  font-family: Arial, sans-serif;
  color: #374151; /* sötétszürke szöveg */
}

.competence-section {
  text-align: center;
  font-family: Arial, sans-serif;
  color: #374151; /* sötétszürke szöveg */
  padding-left: 0;
  padding-right: 0;
}

.section-title {
  font-weight: 700;
  font-size: 1.8rem; /* kb. 20px */
  color: #374151;
  text-align: left;
}

.cards-container {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.goal-card {
  background-color: #e6f0ea; /* halvány zöld háttér */
  flex: 1 1 30%;
  min-width: 260px;
  padding: 2rem;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}
.first-card {
  border-radius: 30px 0 30px 0;
}
.second-card {
  border-radius: 0;
}
.third-card {
  border-radius: 0 30px 0 30px;
}

.goal-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.icon {
  width: 50px;
  height: 50px;
  margin: 0 auto 1rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00903c; /* zöld ikonszín */
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  background-color: white;
}

.icon-svg {
  width: 24px;
  height: 24px;
}

.goal-title {
  font-weight: 700;
  font-size: 1.15rem;
  margin-bottom: 1rem;
  color: #374151;
}

.goal-text {
  background-color: white;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.85rem;
  color: #00903c;
  max-width: 220px;
  margin: 0 auto;
  line-height: 1.2;
}

.competence-wrapper {
  position: relative;
  min-height: 500px;
  background-image: url('../assets/img/ESG/ESG_KK_cover.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  margin-left: -15px;
}

.competence-overlay {
  position: relative;
  width: 60%;
  height: 100%;
}

/* közös box stílus */
.competence-box {
  position: absolute;

  background: white;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  border-radius: 12px;

  padding: 16px 24px;
  min-width: 220px;
  min-height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* szöveg */
.competence-text {
  margin: 0;
  font-weight: 700;
  font-size: 0.95rem;
  color: #00903c;
  text-align: center;
}

.competence-box-1 {
  margin-top: 200px;
  margin-left: 650px;
  position: absolute;
  z-index: 5;
}

.competence-box-2 {
  margin-top: 100px;
  margin-left: 900px;
}

.competence-box-3 {
  margin-top: 200px;
  margin-left: 900px;
}

.competence-box-4 {
  margin-top: 320px;
  margin-left: 900px;
}

.footer-text {
  font-size: 20px;
  color: #6b7280; /* halványszürke */
  margin-top: 3rem;
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4;
  font-weight: bold;
  margin-top: 10px;
}

/* Mobil nézet */
@media (max-width: 768px) {
  .cards-container {
    flex-direction: column;
    gap: 2rem;
    margin-left: -35px;
  }
  .goal-card {
    min-width: auto;
  }
  .section-title {
    font-weight: 700;
    padding: 0;
    font-size: 1.3rem;
  }

  .competence-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }

  .competence-box-mobile {
    background: white;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    padding: 16px;
    text-align: center;
  }

  .competence-box-mobile-1 {
    margin-top: -300px;
    margin-left: 30px;
    position: absolute;
  }

  .competence-box-mobile-2 {
    margin-top: -370px;
    margin-left: 185px;
    width: 110px;
    height: 70px;
    position: absolute;
    font-size: 10px;
  }

  .competence-box-mobile-3 {
    margin-top: -297px;
    margin-left: 185px;
    position: absolute;
    width: 120px;
    height: 110px;
    font-size: small;
  }

  .competence-box-mobile-4 {
    margin-top: -183px;
    margin-left: 185px;
    width: 90px;
    position: absolute;
    font-size: small;
  }

  .competence-text-mobile {
    margin: 0;
    font-weight: 700;
    font-size: 0.95rem;
    color: #00903c;
    font-size: 12px;
  }
}

.esg-diagram {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f7f4; /* halvány zöldes háttér */
  padding: 30px;
  border-radius: 30px;
  max-width: 1140px;
  margin: 0 auto;
}

.left-section,
.middle-section,
.right-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.left-section {
  flex: 2;
  gap: 20px;
}

.item-left {
  display: flex;
  align-items: center;
  background-color: #dff0e2; /* világoszöld */
  border-radius: 0 3rem 3rem 0;
  padding: 15px 30px;
  font-weight: 700;
  color: #008237; /* zöld szöveg */
}
.item-right {
  display: flex;
  align-items: center;
  background-color: #dff0e2; /* világoszöld */
  border-radius: 3rem 0 0 3rem;
  padding: 15px 30px;
  font-weight: 700;
  color: #008237; /* zöld szöveg */
}

.arrow-circle {
  min-width: 30px;
  min-height: 30px;
  background-color: #fff;
  border: 1px solid #008237;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #008237;
  font-weight: bold;
  margin-right: 20px;
}

.middle-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.central-box {
  background-color: #fff;
  padding: 25px 35px;
  border-radius: 12px;
  font-weight: 700;
  color: #008237;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 180px;
}

/* Jobb oldali dobozok */
.right-section {
  flex: 1.3;
  gap: 20px;
}

.service-box {
  background-color: white;
  border-radius: 12px;
  padding: 20px 15px;
  font-weight: 700;
  color: #008237;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

@media (max-width: 575px) {
  h1 {
    font-size: 30px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-size: 20px;
    font-weight: 700;
  }
}

.expert-wrapper {
  cursor: pointer;
  height: 100%;
}

.expert-image-wrapper {
  height: 100%;
}

.expert-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.expert-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-box {
  height: 320px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 768px) {
  .mobile-image {
    display: none;
  }
}

.wrapper {
  background: #f2f8fa;
}
.wrapper-2 {
  position: relative;
  height: 172px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-3 {
  background: #f2f8fa;
  border-radius: 0 100px;
}

.img-shadow {
  box-shadow: -38px 35px #d9eee2;
  border-radius: 40px 0px;
}

.info-box {
  height: 320px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-box-shadow-1 {
  border-radius: 80px 8px 8px 8px;
}
.info-box-shadow-3 {
  border-radius: 8px 80px 8px 8px;
}

.info-box ul {
  text-align: center;
  /* list-style: inside; */
  list-style-position: inside;
}
.info-box li {
  margin-right: 40px;
}

.funding .list-title {
  margin-bottom: -10px;
}
.funding li {
  margin-left: -25px;
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
}

.custom-color {
  color: #00903c;
}

@media (max-width: 992px) {
  .wrapper {
    margin-bottom: 2rem;
  }
  .wrapper-2 {
    height: 222px;
  }

  .info-box {
    margin-bottom: 80px;
  }
  .custom-button {
    width: 100%;
  }
}

/* Cím a kiemelt szakaszoknak (pl. Fenntarthatósági mentorálás) */
.strong-highlight {
  font-family: 'Roboto', sans-serif;
  font-weight: 400; /* Regular */
  font-size: 24px;
  color: #008237;
  margin-bottom: 0.75rem;
}
.services-wrapper ul {
  margin-left: 0;
  padding-left: 1rem;
  line-height: 1.5;
  list-style: none;
  padding-left: 1rem;
  color: #374151;
  font-weight: 400;
  font-size: 0.95rem;
  margin-bottom: 1rem;
}

.services-wrapper ul ul {
  list-style-type: circle;
  margin-left: 1rem;
  font-weight: 700;
  color: #00903c;
  list-style: none;
  padding-left: 1rem;
  margin-top: 0.2rem;
  margin-bottom: 0.9rem;
}

.services-wrapper ol {
  list-style-position: inside;
  color: #374151;
  font-weight: 700;
  font-size: 1rem;
  counter-reset: item;
  padding-left: 0;
  margin-left: 1.2rem;
  content: counter(item) '.';
  font-weight: bold;
}

.services-wrapper li {
  margin-bottom: 0.75rem;
}

.services-wrapper ul ul li {
  position: relative;
  margin-bottom: 0.4rem;
  font-weight: 700;
  color: #008237;
}

.services-wrapper ul ul li::before {
  content: '•';
  color: #008237;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1.2rem;
  line-height: 1;
}

/* E, S, G betűk vastag és zöldek */
.services-wrapper ul ul li strong {
  color: #008237;
  font-weight: 700;
}

/* Pipa ikon + normál szöveg a fő felsorolásban */
.services-wrapper ul > li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  font-weight: 400;
  color: #374151;
  font-size: 0.95rem;
  gap: 0.5rem;
}

.services-wrapper ul > li svg {
  min-width: 20px;
  min-height: 20px;
  margin-top: 0.15rem;
  fill: #008237;
  flex-shrink: 0;
}

.services-wrapper ol li {
  position: relative;
  padding-left: 3.5rem;
  font-size: 0.95rem;
  color: #374151;
  font-weight: 400;
}

.services-wrapper ol li::before {
  counter-increment: item;
  content: counter(item) '.';
  position: absolute;
  left: 1rem;
  background: white;
  color: #008237;
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.85rem;
  line-height: 24px;
}

/* Az egyes pontok leírása */
.services-wrapper ol li p {
  margin-top: 0.4rem;
  color: white;
  font-weight: 400;
  line-height: 1.4;
}
.services-button-wrapper {
  justify-content: space-between;
  color: #008237;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  border: none;
  background: none;
  text-decoration: none;
  transition: color 0.2s ease;
  background-color: white;
  width: 100%;
}

.services-button-wrapper:hover {
  text-decoration: underline;
  background-color: white;
}

.services-button-wrapper svg {
  stroke: none;
  fill: #008237;
  width: 24px;
  height: 24px;
  background-color: white;
}
.dot_section {
  font-weight: normal !important;
  padding: 0 3.5rem;
  font-size: 0.9rem;
}

.dot {
  list-style: none;
  padding-left: 0;
}

.dot li {
  position: relative;
  padding-left: 30px;
}

.dot li::before {
  content: '•';
  color: #008237; /* zöld bullet */
  font-size: 30px; /* állítható méret */
  position: absolute;
  left: 0;
  top: 0;
  line-height: 1;
}

.p-1 {
  font-weight: bold;
}

.p-2 {
  margin-left: -2px;
}

.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
  width: 480px;
  margin-left: 30px;
}

.p-0 img {
  margin-left: -80px;
  max-width: 160%;
  margin-top: 60px;
}

@media (max-width: 575px) {
  .button {
    background: #00903c;
    font-weight: 700;
    color: #fff;
    height: 48px;
    line-height: 32px;
    border-radius: 8px;
    width: 350px;
    margin-left: 5px;
  }
  .dot_pill_2 {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    padding: 10px 18px;
    min-width: 360px;

    background: #ffffff; /* világos szürke */
    border-radius: 999px; /* pill forma */

    text-decoration: none;
    color: #00903c;
    font-weight: 800;
    font-size: 20px;

    transition: all 0.2s ease;
  }

  .goal-card {
    background-color: #e6f0ea; /* halvány zöld háttér */
    flex: 1 1 20%;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease-in-out;
  }
  .first-card {
    border-radius: 30px 0 30px 0;
  }
  .second-card {
    border-radius: 0;
  }
  .third-card {
    border-radius: 0 30px 0 30px;
  }

  .goal-card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  }

  .footer-text {
    font-size: 13px;
    font-weight: bolder;
    color: #6b7280; /* halványszürke */
    margin-top: 3rem;
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.4;
    font-weight: bold;
    margin-top: 10px;
  }
}
</style>
